import { api } from 'pages/APIs';
import AbstractApiService from 'src/services/abstractApiService';
import type { dynamicObj } from 'src/pages/assets';

export default class FullSearchApiService extends AbstractApiService {
  public constructor() {
    super({});
  }

  public async getFullSearchDashboard(formdata: FormData): Promise<any> {
    return super.post(api.open_search_documents, formdata);
  }

  /**
   * Get faceted aggregations for filter panels.
   * Returns counts by doc_type, status, vendor, amount ranges, etc.
   */
  public async getSearchFacets(formdata: FormData): Promise<any> {
    return super.post(api.open_search_facets, formdata);
  }

  /**
   * Get autocomplete suggestions for search queries.
   * Returns suggestions for vendors, filenames, invoice numbers.
   */
  public async getSearchSuggestions(formdata: FormData): Promise<any> {
    return super.post(api.open_search_suggestions, formdata);
  }

  /**
   * Find documents similar to a given document using k-NN vector search.
   * Returns similar documents with similarity scores and facet breakdown.
   *
   * @param docId - Document ID to find similar documents for
   * @param k - Number of similar documents to return (default: 10, max: 50)
   * @param excludeSameDocType - If true, exclude documents with same doc_type
   */
  public async getSimilarDocuments(
    docId: string,
    k: number = 10,
    excludeSameDocType: boolean = false
  ): Promise<any> {
    const formdata = new FormData();
    formdata.append('k', k.toString());
    formdata.append('exclude_same_doc_type', excludeSameDocType.toString());
    return super.post(`${api.open_search_similar}/${docId}`, formdata);
  }

  public async createOpenSearchIndex(): Promise<any> {
    return super.post(api.create_open_search_index, new FormData());
  }

  public async deleteOpenSearchIndex(): Promise<any> {
    return super.post(api.delete_open_search_index, new FormData());
  }
}
